import React, { useRef } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import FeaturesSection from "../components/feature/FeaturesSection";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import Testimonials from "../components/Testimonials";
import ChatBox from "../components/chat/ChatBox";
import { ChatProvider } from "../contexts/ChatContext";

function LandingPage() {
  const featuresRef = useRef(null); // Create a reference for FeaturesSection
  const chatBoxRef = useRef(null); // Create a reference for ChatBox
  return (
    <div>
      <ChatProvider>
        <div className="bg-gray-100">
          <HeroSection featuresRef={featuresRef} />

          {/* Features Section */}
          <section
            id="features-section"
            className="flex items-center justify-center bg-gradient-to-b from-gray-800 to-black"
          >
            <FeaturesSection ref={featuresRef} chatBoxRef = {chatBoxRef}/>
          </section>

          {/* Chat Section */}
          <section
            id="chat-section"
            className="flex flex-col h-screen bg-gradient-to-b from-gray-800 to-black"
          >
            <div className="flex-1 flex items-center justify-center">
              <h3 className="text-2xl font-bold text-white text-center mb-6 mt-6">
                Know more with our AI Agent
              </h3>
            </div>
            <div className="flex-1">
              <ChatBox ref={chatBoxRef}/>
            </div>
          </section>
        </div>
      </ChatProvider>
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default LandingPage;